var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"qrcodeView"},[(_vm.imgData != '')?_c('img',{attrs:{"src":_vm.imgData}}):_vm._e(),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.imgData == ''),expression:"imgData == ''"}],staticClass:"qrcode",attrs:{"id":_vm.qrid}})])
}
var staticRenderFns = []

export { render, staticRenderFns }